export default "__VITE_ASSET__dd465edd__"